<template>
  <div class="delivery-order-buttons-wrapper">
    <div
      v-if="!isResolvedWithReOrder && !isResolvedWithoutReOrder && hasUnsuccessfullyStatus"
      class="actions-area"
    >
      <h6>Please select a resolution</h6>
      <router-link
        :to="getReorderPath(order, true)"
        class="btn btn-purple"
      >
        Resolve with Re-order
      </router-link>
      OR
      <span
        class="btn btn-purple btn-reorder"
        @click.prevent="resolveOrderWithoutReorder(order.id)"
      > Resolve without Re-order </span>
      <br>
      <sup> *Please note that due to this order failing to be delivered, the CX has not be charged. </sup>
    </div>
    <div
      v-if="isResolvedWithReOrder"
      class="actions-area"
    >
      <h6>This order was not delivered</h6>
      <span>
        The following order resolved this order:
        <router-link
          :to="`/partner/delivery-orders/${order.relatedPath.orderResolution.resolvedByOrderID}`"
          target="_blank"
        >
          Order Id: {{ order.relatedPath.orderResolution.resolvedByOrderID }}
        </router-link>
        <br>
        <sup> *Please note that due to this order failing to be delivered, the CX has not be charged. </sup>
      </span>
    </div>
    <br v-if="isResolvesOrder && !isResolvedWithoutReOrder && !isResolvedWithReOrder && hasUnsuccessfullyStatus">
    <div
      v-if="isResolvesOrder"
      class="actions-area"
    >
      <h6>This order resolved a failed order</h6>
      <span>
        The following order was resolved by this order:
        <router-link
          :to="`/partner/delivery-orders/${order.relatedPath.orderResolution.resolvedOrderID}`"
          target="_blank"
        >
          Order Id: {{ order.relatedPath.orderResolution.resolvedOrderID }}
        </router-link>
        <br>
      </span>
    </div>
    <br v-if="isResolvesOrder">
    <div class="action-area">
      <router-link
        v-if="!hasUnsuccessfullyStatus || isResolvedWithoutReOrder"
        :to="getReorderPath(order, false)"
        class="btn btn-purple"
      >
        Re-Order
      </router-link>
      <span
        v-if="isAllowToMarkOrder"
        class="btn btn-warning ml-2"
        @click.prevent="markOrderAsCanceled(order.id)"
      > Mark as Canceled </span>
      <span
        v-if="isAllowToMarkOrder"
        class="btn btn-success ml-2"
        @click.prevent="markOrderAsCompleted(order.id)"
      >
        Mark as Completed
      </span>
      <span
        v-if="isAllowToMarkOrder && isUnpaidOrder"
        class="btn btn-info ml-2"
        @click.prevent="markOrderAsDoNotCharge(order.id)"
      >
        Do Not Charge Order
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import queryString from 'query-string';

import utils from '@/Utils/util';
import { computed } from 'vue';

export default {
  props: {
    order: {
      type: Object,
      required: true,
    },

    isAllowToMarkOrder: {
      type: Boolean,
      default: true,
    },
  },

  emits: ['resolve-order-without-reorder', 'mark-order-as-canceled', 'mark-order-as-completed', 'mark-order-as-do-not-charge'],

  setup: (props: any, context: any) => {
    const { emit } = context;

    const hasUnsuccessfullyStatus = computed(() => utils.hasUnsuccessfullyStatus(props.order));

    const isResolvedWithReOrder = computed(() => utils.isResolvedWithReOrder(props.order));

    const isResolvedWithoutReOrder = computed(() => utils.isResolvedWithoutReOrder(props.order));

    const isResolvesOrder = computed(() => utils.isResolvesOrder(props.order));

    const isUnpaidOrder = computed(() => props.order.paidStatus === 'unpaid');

    const resolveOrderWithoutReorder = (orderId: any) => {
      emit('resolve-order-without-reorder', orderId);
    };

    const markOrderAsCanceled = (orderId: any) => {
      emit('mark-order-as-canceled', orderId);
    };

    const markOrderAsCompleted = (orderId: any) => {
      emit('mark-order-as-completed', orderId);
    };

    const markOrderAsDoNotCharge = (orderId: any) => {
      emit('mark-order-as-do-not-charge', orderId);
    };

    const getReorderPath = (order: any, resolved: boolean = false) => {
      const query = {
        phoneNumber: order.caller.phoneNumber,
      } as any;
      if (resolved) {
        query.resolveOrder = true;
      }
      const queryParams = queryString.stringify(query);
      return `/operator/delivery-search/${order.id}?${queryParams}`;
    };

    return {
      hasUnsuccessfullyStatus,
      isResolvedWithReOrder,
      isResolvedWithoutReOrder,
      isResolvesOrder,
      isUnpaidOrder,
      resolveOrderWithoutReorder,
      markOrderAsCanceled,
      markOrderAsCompleted,
      markOrderAsDoNotCharge,
      getReorderPath,
    };
  },
};
</script>
